import { render, staticRenderFns } from "./Breaks.vue?vue&type=template&id=4e1a416c&scoped=true&"
import script from "./Breaks.vue?vue&type=script&lang=js&"
export * from "./Breaks.vue?vue&type=script&lang=js&"
import style0 from "./Breaks.vue?vue&type=style&index=0&id=4e1a416c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a416c",
  null
  
)

export default component.exports